import { Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import React, { useEffect } from 'react'
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: '#fff',
    color: 'blue',
    border: '1px solid blue',
    borderRadius: '3px',
  },
  '&:hover': {
    color: 'white',
    backgroundColor: 'blue',
    borderColor: 'white',
    boxShadow: 'none',
  },
  button: {
    // marginTop: theme.spacing(3),
    // marginLeft: theme.spacing(1),
  },
}))

interface ButtonBackProps {
  handleClick: any
  show_button: boolean
}

export default function ButtonBack(props: ButtonBackProps) {
  const classes = useStyles()

  useEffect(() => {
    // setTimeout(function () {
    //   window.location.replace(props.sendTo)
    // }, props.timeout || 2000)
  })

  if (props.show_button) {
    return (
      <React.Fragment>
        <Button className={classes.button} onClick={props.handleClick}>
          <ChevronLeftIcon fontSize="large" />
        </Button>
      </React.Fragment>
    )
  } else {
    return <React.Fragment></React.Fragment>
  }
}
